var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"app-logo"},[_c('iconic',{attrs:{"name":"mf_logo_shadow","options":{ original: true }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }